import React from 'react';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

export type EngagementsViewStateBannerInterviewedProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
};

export const EngagementsViewStateBannerInterviewed: React.FC<
  EngagementsViewStateBannerInterviewedProps
> = ({ engagement, name = 'ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWED' }) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="INTERVIEWED_HEADER">
          Next Step: Client response
        </ParagraphHeader>
        <Paragraph name="INTERVIEWED_MESSAGE_1">
          We're currently working with the client to determine next steps. While
          we do that, please take a moment to note your impressions from the
          client conversation while it's top of mind. This feedback will be
          helpful when Axiom follows up with you.
        </Paragraph>
        {engagement.opportunity.ownerUser ? (
          <Paragraph name="INTERVIEWED_MESSAGE_2">
            Missed your interview? Reach out to{' '}
            <a href={`mailto:${engagement.opportunity.ownerUser.email}`}>
              {engagement.opportunity.ownerUser.fullName}
            </a>
            .
          </Paragraph>
        ) : null}
      </Layout>
    </Banner>
  );
};
